import React, { PropsWithChildren } from "react";
import styles from "./vpd-scrollable.css";
import clsx from "clsx";

const { ["container"]: containerClassName } = styles as any;

export type VpdScrollableProps = PropsWithChildren<{
  className?: string;
}>;

export const VpdScrollable: any = React.forwardRef(function VpdScrollable(
  { className, children }: VpdScrollableProps,
  ref: any
) {
  return (
    <div className={clsx(containerClassName, className)}>
      <div ref={ref}>{children}</div>
    </div>
  );
});
